export const MIN_CREDITS_TO_UNLOCK_IMAGE = 3;
